import { Page } from './page';
export class Item {
  public id: number;
  public updated_at: string;
  public created_at: string;
  public page: Page;
  public children: Item[];

  constructor(data: Item) {
    Object.assign(this, data);
    if (this.page) {
      this.page = new Page(this.page);
    }
  }
}
